<template>
    <div v-if="bizAuth.createPaperContract.hasRight" class="page-setting has-bc house-new-econtract">
        <div class="page-header">
            <h1>
                {{$route.meta.title}}
                <word-tips-hover data="此情境用於您與租客在線下環境已達成簽約共識，可在飛豬管家跳過預定流程，直接簽立電子合約。" width="424px"></word-tips-hover>
            </h1>
        </div>
        <new-e-contract></new-e-contract>
    </div>
</template>
<script>
import NewEContract from '@/components/bussiness/mgtCategory/leaseMgt/newContract/NewEContract.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'

export default {
    name: 'HouseManagement',
    data () {
        return {
            // houseFilter: false,
            listIsFixed: false,
        }
    },
    watch: {
        'bizAuth.createPaperContract.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        NewEContract,
        wordTipsHover
    }
}
</script>
<style lang="scss" >
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/leaseMgt/newEContractFrame.vue